module.exports = __webpack_public_path__ + "static/img/Savelio_Tamale.1b122cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Savelio_Tamale.jpg
// module id = BnTD
// module chunks = 0